<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-md-9 hidden-sm hidden-xs no-float left-part-wrap">
        <div class="left-part">
          <div class="logo">
            <img src="../images/logo-login.svg" alt="">
          </div>
          <div class="title-wrap">
            <h1 class="main-title"> {{ $t('Demand Side') }} </h1>
            <h2 class="main-sub-title"> {{ $t('Platform') }} </h2>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-12 no-float right-part-wrap">
        <div class="login-mobile-top">
          <div class="mobile-logo">
            <img src="../images/mobile-logo.svg" alt="">
          </div>
          <div class="mobile-title">Demand Side <span>Platform</span></div>
        </div>
        <div class="content">
          <div v-if="confirmToken && verifyConfirmToken===true" class="сonfirm-complete">
            <div class="icon">
              <!--              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--                <path fill-rule="evenodd"-->
              <!--                      clip-rule="evenodd"-->
              <!--                      d="M56.7678 8.23223C57.7441 9.20854 57.7441 10.7915 56.7678 11.7678L31.7678 36.7678C30.7915 37.7441 29.2085 37.7441 28.2322 36.7678L20.7322 29.2678C19.7559 28.2915 19.7559 26.7085 20.7322 25.7322C21.7085 24.7559 23.2915 24.7559 24.2678 25.7322L30 31.4645L53.2322 8.23223C54.2085 7.25592 55.7915 7.25592 56.7678 8.23223Z"-->
              <!--                      fill="#740B99"/>-->
              <!--                <path fill-rule="evenodd"-->
              <!--                      clip-rule="evenodd"-->
              <!--                      d="M12.5 10C11.837 10 11.2011 10.2634 10.7322 10.7322C10.2634 11.2011 10 11.837 10 12.5V47.5C10 48.163 10.2634 48.7989 10.7322 49.2678C11.2011 49.7366 11.837 50 12.5 50H47.5C48.163 50 48.7989 49.7366 49.2678 49.2678C49.7366 48.7989 50 48.163 50 47.5V30C50 28.6193 51.1193 27.5 52.5 27.5C53.8807 27.5 55 28.6193 55 30V47.5C55 49.4891 54.2098 51.3968 52.8033 52.8033C51.3968 54.2098 49.4891 55 47.5 55H12.5C10.5109 55 8.60322 54.2098 7.1967 52.8033C5.79018 51.3968 5 49.4891 5 47.5V12.5C5 10.5109 5.79018 8.60322 7.1967 7.1967C8.60322 5.79018 10.5109 5 12.5 5H40C41.3807 5 42.5 6.11929 42.5 7.5C42.5 8.88071 41.3807 10 40 10H12.5Z"-->
              <!--                      fill="#740B99"/>-->
              <!--              </svg>-->
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.5 47.5H12.5C11.1739 47.5 9.90215 46.9732 8.96447 46.0355C8.02678 45.0978 7.5 43.8261 7.5 42.5V17.5C7.5 16.1739 8.02678 14.9021 8.96447 13.9645C9.90215 13.0268 11.1739 12.5 12.5 12.5H47.5C48.8261 12.5 50.0978 13.0268 51.0355 13.9645C51.9732 14.9021 52.5 16.1739 52.5 17.5V32.5"
                      stroke="#740B99"
                      stroke-width="5"
                      stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M7.5 17.5L30 32.5L52.5 17.5M37.5 47.5L42.5 52.5L52.5 42.5"
                      stroke="#740B99"
                      stroke-width="5"
                      stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="form-title">{{ $t('Verification') }}<br> {{ $t('complete') }}!</h3>
            <p class="text-center">{{ $t('Thank you for verifying email!') }}
              <br>{{ $t('Our team will consider your') }} {{ $t('application and contact you by email') }}
              <br> {{ $t('regarding further steps.') }}</p>
          </div>
          <div class="wrap" v-else>
            <b-tabs v-model="activeTab" nav-class="login-toggle">
              <b-tab :title="$t('Registration')" :active="openSignInTab !== 'yes'">
                <SignUp v-if="pageLoaded&&activeTab==0" @backToLogin="activeTab=2"/>
              </b-tab>
              <b-tab :title="$t('Login')" :active="openSignInTab === 'yes' || confirmToken !== '' || resetToken !== ''">
                <form v-if="!ForgotPass && !ResetPass" v-on:submit.prevent="login" id="dsp-login-form">
                  <!--                  <b-alert v-if="confirmToken && verifyConfirmToken===true" dismissible fade variant="success" show>{{-->
                  <!--                      $t('Thank you for confirming your email. You may now log in to access your account.')-->
                  <!--                    }}-->
                  <!--                  </b-alert>-->
                  <div v-if="confirmToken && verifyConfirmToken===true">

                  </div>
                  <div v-else>
                    <b-alert v-if="confirmToken && verifyConfirmToken===false"
                             dismissible
                             fade
                             variant="danger"
                             show> {{
                        $t('Cannot find user for email verification. Please try again or contact support from')
                      }} <a href="mailto:support@smartyads.com">support@smartyads.com</a></b-alert>
                    <div :class="{ 'has-error' : formLogin.hasError||errors.has('email') }" class="form-group">
                      <label for="log-email" class="form-control-placeholder">{{ $t('E-mail') }} <span>*</span></label>
                      <input v-model.trim="formLogin.email"
                             v-validate="'required|email'"
                             @change="formLogin.hasError=false"
                             :data-vv-as="$t('E-mail')"
                             type="text"
                             name="email"
                             dusk="log-mail"
                             class="form-control form-control-solid"
                             id="log-email"
                             required=""

                             aria-required="true"> <span :title="errors.first('email')||formLogin.msgError"
                                                         class="help-block alt tooltips"
                                                         v-show="formLogin.status===401"
                                                         v-b-tooltip.hover><span class="error-sign"></span></span>
                    </div>
                    <div :class="{ 'has-error' : formLogin.hasError||errors.has('password') }" class="form-group">
                      <label for="log-password" class="form-control-placeholder">{{ $t('Password') }}
                        <span>*</span></label> <input v-model.trim="formLogin.password"
                                                      v-validate="'required|min:6'"
                                                      :data-vv-as="$t('Password')"
                                                      @change="formLogin.hasError=false"
                                                      name="password"
                                                      dusk="log-pass"
                                                      type="password"
                                                      class="form-control form-control-solid"
                                                      id="log-password"
                                                      required=""
                                                      aria-required="true"
                                                      autocomplete="off">
                      <span :title="errors.first('password') ||$t(formLogin.msgError)"
                            class="help-block alt tooltips"
                            v-show="formLogin.status===401"
                            v-b-tooltip.hover><span class="error-sign"></span></span>
                    </div>
                    <div class="input-wrap has-error" v-show="formLogin.hasError===true && formLogin.status===403">
                      <div class="help-text" style="">{{ formLogin.msgError }}</div>
                    </div>

                    <div v-if="formLogin.hasError===true && formLogin.status===403 && formLogin.msgError && formLogin.msgError.toLowerCase().includes('not verified')"
                         class="form-group">
                      <div class="mt-2">
                        <span>{{ $t('Didn\'t receive a verification email?') }} </span> <span v-if="resendSuccess"
                                                                                              class="success-icon"
                                                                                              style="display:inline-block;vertical-align:middle;margin-left:8px;">
                          <svg width="24"
                               height="24"
                               viewBox="0 0 48 48"
                               fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <circle cx="24" cy="24" r="24" fill="#740B99"/>
                            <path d="M34 18L22 30L14 22"
                                  stroke="#fff"
                                  stroke-width="3"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>
                          </svg>
                        </span> <a v-else
                                   @click="autoResend"
                                   :style="'color:#740B99;cursor:pointer;font-weight:600;margin-left:8px;text-decoration:none;'"> {{ resendLoading ? $t('Sending...') : $t('Resend') }} </a>
                      </div>
                    </div>

                    <div class="rememberme">
                      <input v-model="formLogin.remember" type="checkbox" name="remember" id="remember">
                      <label class="alt rem" for="remember">{{ $t('Remember Me') }}</label>
                    </div>
                    <div class="form-actions text-center">
                      <button :disabled="this.errors.count()!==0"
                              type="submit"
                              dusk="log-bnt"
                              class="button primary w-100">{{ $t('Login') }}
                      </button>
                      <a v-on:click="ForgotPass = !ForgotPass"
                         href="#"
                         id="forget-password"
                         class="forget-password"> {{ $t('Forgot Password') }}? </a>
                      <div class="form-group mt-20">
                                            <span class="terms-link">
                                                <a href="https://smartyads.com/terms-of-service"
                                                   target="_blank"
                                                   data-page="termofservice"
                                                   data-pagetitle="Terms of service"> {{ $t('Terms of service') }}</a> |
                                                <a href="https://smartyads.com/services-privacy-policy"
                                                   target="_blank"
                                                   data-page="privacypolicy"
                                                   data-pagetitle="Privacy Policy"> {{ $t('Services Privacy Policy') }}</a>
                                            </span>
                      </div>
                    </div>
                    <div class="form-group text-center">
                      <span class="terms-link">By logging in/registering an account, you acknowledge that your personal data will be processed in accordance with our  </span>
                      <span class="terms-link"><a href="https://smartyads.com/services-privacy-policy"
                                                  target="_blank">Services Privacy Policy</a>.
                                        </span>
                    </div>
                    <div class="copyrights mt-30">2011-2026 &copy; SmartyAds. All Rights Reserved</div>
                  </div>

                </form>

                <Forgot v-if="ForgotPass" :isForgotPass="ForgotPass" v-on:getForgotPass="setForgotPass"/>

                <Reset v-if="ResetPass"
                       :isResetPass="ResetPass"
                       v-on:getResetPass="setResetPass"
                       :resetToken="resetToken"/>

              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignUp from '../components/login/SignUp.vue';
import Forgot from '../components/login/Forgot.vue';
import Reset from '../components/login/Reset.vue';

export default {
  name: 'login',

  metaInfo: {
    meta: [{
      name: 'viewport',
      content: 'width=device-width,initial-scale=1.0'
    },],
  },

  components: {
    SignUp,
    Forgot,
    Reset,
  },

  data: function () {
    return {
      activeTab: 1,
      pageLoaded: false,
      confirmToken: this.$route.params.confirmToken || '', // confirmToken: true,
      resetToken: this.$route.params.resetToken || '',
      verifyConfirmToken: null, // verifyConfirmToken: true,
      ForgotPass: false,
      ResetPass: false,
      formLogin: {
        email: '',
        password: '',
        remember: false,
        hasError: false,
        msgError: 'Email or Password is incorrect',
        status: 401,
      },
      resendLoading: false,
      resendSuccess: false,
      resendTimer: null,
    };
  },

  computed: {
    openSignInTab () {
      return this.$route.query.openSignInTab || 'no';
    },
    redirectUrl () {
      const redirect = this.$route.query.redirect;

      return typeof redirect === 'string' && redirect !== '' ? redirect : null;
    }
  },

  provide: function () {
    return {
      sendGTag: this.sendGTag
    };
  },

  created () {
    this.$auth.ready(function () {
      if (this.resetToken) {
        return;
      }

      if (this.$auth.check()) {
        if (this.redirectUrl) {
          window.location.assign(this.redirectUrl);
          return;
        }

        this.$router.push({ name: 'dashboard' });
      }
    }.bind(this));
  },

  mounted: function () {
    // Костыль для верстки
    document.body.classList.add('login-page');

    // Костыль для капчи
    this.$nextTick(() => {
      setTimeout(() => {
        this.pageLoaded = true;
      }, 1000);
    });
    if (this.confirmToken) {
      this.confirm();
    }
    if (this.resetToken) {
      this.ResetPass = true;
    }
  },

  destroyed () {
    // Костыль для верстки
    document.body.classList.remove('login-page');
    if (this.resendTimer) clearTimeout(this.resendTimer);
  },

  methods: {
    setForgotPass (state) {
      this.ForgotPass = state;
    },
    setResetPass (state, email) {
      this.ResetPass = state;
      if (email) {
        this.formLogin.email = email;
      }
      this.formLogin.password = '';
    },
    login () {
      this.formLogin.hasError = false;

      this.$auth.login({
        context: this,
        params: {
          email: this.formLogin.email,
          password: this.formLogin.password,
          hubspotutk: this.$cookies.get('hubspotutk') ? this.$cookies.get('hubspotutk') : 'empty'
        },
        success: function () {
          this.sendGTag('login', 'dsp');

          if (this.verifyConfirmToken) {
            this.$store.commit('main/isFirstLoginTour', true);
            this.$store.commit('main/isFirstCreativeBuilderTour', true);
          }

          if (this.redirectUrl) {
            window.location.assign(this.redirectUrl);
          }
        },
        error: function () {
          // this.formLogin.hasError = true;
        },
        rememberMe: this.formLogin.remember,
      }).catch(error => {
        this.formLogin.msgError = error.response.data.error;
        this.formLogin.status = error.response.status;
        this.formLogin.hasError = true;
      });
    },
    confirm () {
      this.$axios
          .post('/users/account/confirm/' + this.confirmToken)
          .then(() => {
            this.verifyConfirmToken = true;
            this.$router.replace({ name: 'login', query: { openSignInTab: 'yes' } });
            this.verifyConfirmToken = true;
          })
          .catch(() => {
            this.verifyConfirmToken = false;
            this.$router.replace({ name: 'login', query: { openSignInTab: 'yes' } });
          });

    },
    async autoResend () {
      this.resendLoading = true;
      try {
        this.resendSuccess = true;
        await this.$axios.post('users/resendVerification', { email: this.formLogin.email });
        this.$notify.info(this.$t('Verification email sent!'));
        if (this.resendTimer) clearTimeout(this.resendTimer);
        this.resendTimer = setTimeout(() => {
          this.resendSuccess = false;
        }, 60000);
      } catch (e) {
        this.$notify.error(this.$t('Failed to send verification email'));
      } finally {
        this.resendLoading = false;
      }
    },
    inProduction () {
      return process.env.VUE_APP_ENV === 'production';
    },
    hasGAConfigured () {
      return !!process.env.VUE_APP_GOOGLE_ANALYTICS_ID;
    },
    gaInTestMode () {
      return window.gatest;
    },
    sendGTag (eventName, methodName) {
      if ((this.inProduction() && this.hasGAConfigured()) || this.gaInTestMode()) {
        try {
          window.gtag('event', eventName, { 'method': methodName });
        } catch (e) {
          // eslint-disable-next-line
          console.error(e.toString());
        }
      }
    },
  }

};
</script>
<style lang="scss" scoped>
@import "../scss/components/checkboxlogin";

.copyrights {
  text-align: center;
  font-size: 12px;
}

.сonfirm-complete {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h3.form-title {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
.form-group {
  font-size: 12px;
}
</style>
